import { combineClassnames } from 'app/common/presentation'
import { InfoTooltip } from 'app/common/presentation/InfoTooltip'

import styles from './Section.module.scss'

interface SectionProps {
  divider?: boolean
  info?: string
  name: string
  period?: string
}
const Section = ({ divider = true, info, name, period }: SectionProps) => (
  <div
    className={combineClassnames(styles.section, divider ? styles.divider : undefined)}
    data-testid="section"
  >
    <div className={styles.content}>
      <h2 className={styles.name}>{name}</h2>
      {info && <InfoTooltip message={info} />}
    </div>
    {period && <div className={styles.period}>{period}</div>}
  </div>
)

export default Section
